import React from "react";

import { Layout } from "@/components/ui";

interface FullPageProps {
  children: React.ReactNode;
}

const FullPage: React.FC<FullPageProps> = ({ children }) => {
  return (
    <Layout.Main className="pb-0! md:col-span-12! lg:col-span-9! lg:overflow-hidden">
      {children}
    </Layout.Main>
  );
};

export default FullPage;
